// Real Amazon US five-star reviews retrieved through Sorftime MCP.
// Reviews are resolved at the parent-product-family level across all available child variations.
window.BARN_STABLE_AMAZON_REVIEWS = {
  "syncedAt": "2026-09-01",
  "marketplace": "Amazon US",
  "source": "Sorftime MCP",
  "homepage": [
    {
      "family": "mesh",
      "index": 0
    },
    {
      "family": "winter600",
      "index": 0
    },
    {
      "family": "muzzle",
      "index": 0
    },
    {
      "family": "spurs",
      "index": 1
    }
  ],
  "byFamily": {
    "stableBlanket610": [],
    "sheet420": [],
    "sheet600": [
      {
        "variant": "Crimson Red / Black · 69 in",
        "date": "20260204",
        "rating": 5,
        "title": "Great Fit",
        "content": "Amazing"
      }
    ],
    "mesh": [
      {
        "variant": "White - Curvy Fit · 81 in",
        "date": "20260413",
        "rating": 5,
        "title": "Great fly sheet!!",
        "content": "Well constructed!! Light weight beautiful sheet!! The curvy cut is perfect! The straps do run large but I ordered up. I love the uv protection! Thanks!!"
      }
    ],
    "winter600": [
      {
        "variant": "Navy-Red · 78 Inch",
        "date": "20260222",
        "rating": 5,
        "title": "Mid sheet",
        "content": "Nice blanket for the price. Has some insulation. I was expecting none, so if you want a sheet, this is not it. It’s a medium type blanket. Between a sheet and medium I would say. Fits great too"
      },
      {
        "variant": "Navy-Gray · 75 Inch",
        "date": "20260214",
        "rating": 5,
        "title": "Barn and stable horse blanket",
        "content": "Great blanket for our horses in California winter weather"
      },
      {
        "variant": "Ancora Red/Senior Grey · 72 Inch",
        "date": "20260205",
        "rating": 5,
        "title": "Nice hores blanket",
        "content": "This horse blanket is just as it says it is. Fits my horse perfectly and I rarely have to adjust it. And she looks great in it!!"
      },
      {
        "variant": "Ashley Blue/Navy · 78 Inch",
        "date": "20260204",
        "rating": 5,
        "title": "Great quality and value",
        "content": "Super nice and quality. Fast shipping"
      },
      {
        "variant": "Navy-Red · 75 Inch",
        "date": "20260128",
        "rating": 5,
        "title": "Great quality",
        "content": "Excellent quality Blakey. Waterproof and fit great. Easy to apply to the horse and arrived quickly."
      },
      {
        "variant": "Navy-Red · 78 Inch",
        "date": "20260122",
        "rating": 5,
        "title": "Well made and sturdy quality!",
        "content": "I am very impressed with the quality of this blanket. It has all the features of higher priced blankets. The lining is good quality and just enough filling to keep the chill off but not overheat. It has both velcro and very sturdy buckles in front, and cross-belly bands and leg straps. A very nice blanket for the price."
      },
      {
        "variant": "Red/Navy · 75 Inch",
        "date": "20260115",
        "rating": 5,
        "title": "Good quality and fit",
        "content": "Very durable and has done wonders on my older horse."
      },
      {
        "variant": "Navy-Gray · 72 Inch",
        "date": "20260115",
        "rating": 5,
        "title": "Quality and good fit very happy",
        "content": "This is a quality stable blanket - fits well well padded I haven’t tested it’s waterproof quality but it is exactly what I was looking for for fit on a senior horse that had need of new jacket."
      },
      {
        "variant": "Navy-Red · 72 Inch",
        "date": "20260102",
        "rating": 5,
        "title": "Decent blaket",
        "content": "I really like this blanket. Fastens and fits nicely and seems warm enough for my mare. I have noticed that the “barn and stable\" tag is now coming off the side though. Purchased about a month ago. Would buy again."
      },
      {
        "variant": "Navy-Red · 75 Inch",
        "date": "20251207",
        "rating": 5,
        "title": "Good quality, good value",
        "content": "Good quality, great fit for my quarter horse and warm enough for nights in the 40’s"
      },
      {
        "variant": "",
        "date": "20260227",
        "rating": 5,
        "title": "Definitely recommend",
        "content": "Very nice quality and fit my horse perfectly!! Love this blanket!"
      },
      {
        "variant": "",
        "date": "20260104",
        "rating": 5,
        "title": "Excellent quality, longer sides to cover belly",
        "content": "This is a quality blanket. I love that it comes down longer on the sides than most blankets. This stops the wind from hitting his belly. It also keeps the pee off of his hair when he lays down in his stall. The belly straps and leg straps are great and haven‘t come undone even when he rolls on his back or runs like an idiot thru his field. Zero complaints! A++++"
      }
    ],
    "winter1680": [],
    "muzzle": [
      {
        "variant": "Orange · X-Large",
        "date": "20260424",
        "rating": 5,
        "title": "Does it job",
        "content": "Works well. Fits nice. Does its job. Nicely made and stitched"
      },
      {
        "variant": "Black · Large",
        "date": "20260331",
        "rating": 5,
        "title": "Large size. No more cribbing.",
        "content": "If you’re unsure about buying it just do it. I got the Large. My stud had a HORRIBLE cribbing habit for years before I got him. To the point of almost having no top front teeth. Tried hot wire, cribbing collars, ulcer guard and everything else. Nothing worked. This grazing muzzle has been a blessing! I had it on him for most of the day besides a couple hours while eating. He can’t crib with it on. He wore it like that for about 5 days and now wears it only when I see he’s trying to crib. He CAN eat and drink comfortably with it on. But only wears it moderately now and it’s helping tremendously. His teeth are even growing back 🫶🏻"
      },
      {
        "variant": "Black · Large",
        "date": "20260216",
        "rating": 5,
        "title": "Nice and lightweight",
        "content": "Very nice, lightweight and safe grazing muzzle. I really liked how light this muzzle and was and the fact that the velcro attachments would come apart super easy if caught. Very little grazing can be done with this mask on, so if you are trying to have your horse eat, this would prevent most grazing."
      },
      {
        "variant": "Black · Small",
        "date": "20260215",
        "rating": 5,
        "title": "Good Product",
        "content": "Exactly what we needed, we put on occasionally and no issues. Able to eat and drink with it on."
      },
      {
        "variant": "Black · Medium",
        "date": "20250902",
        "rating": 5,
        "title": "Grazing muzzle",
        "content": "This muzzle is great for my 12 hand Hackney/Welsh pony. There are many adjustments and I  like that hole is reinforced. Fits his small head great!"
      }
    ],
    "flyMask": [],
    "girth": [],
    "spurs": [
      {
        "variant": "",
        "date": "20251123",
        "rating": 5,
        "title": "Value Spurs and Straps",
        "content": "Great bang for the buck spurs and straps. The spur’s material itself is nice and won’t rust over time. The pair comes with nylon straps which is nice because spurs can’t function without straps to hold them on. That being said, the straps are sturdy and easy to adjust. So for $15 with free shipping what a deal! Also, I never leave a comment about packaging but after reading several reviews that did I feel the need to address it. Yes, the packaging looks dated and distorts the color is the spurs to a gold look when they are actually silver but who cares?!? Packaging goes right in the trash and there is a reason for product descriptions. Sheesh!"
      },
      {
        "variant": "",
        "date": "20251120",
        "rating": 5,
        "title": "Perfect Gentle Spurs for My Sensitive OTTB!",
        "content": "These BARN & STABLE Never Rust English Riding Spurs are exactly what I needed for my OTTB who sometimes needs just a little extra leg. They’re lightweight, comfortable, and the flat-end design is super humane, just enough encouragement without ever feeling harsh.\nThe 3-inch universal fit works great with my boots, and the adjustable nylon straps stay secure during rides. I also love that they’re nickel-plated and won’t rust, which is a huge bonus for barn life.\n\nOverall, these provide the perfect amount of subtle communication for a sensitive or green horse. Great quality, great price, and they’ve made schooling rides smoother and more responsive. Highly recommend!"
      },
      {
        "variant": "",
        "date": "20251115",
        "rating": 5,
        "title": "Built solid & with a reliable fit! These are great!",
        "content": "Solid construction and a reliable fitI’m very pleased with the Never Rust English Riding Spurs. The nickel-plated zinc alloy feels durable, and they truly don’t rust, even after getting caught in wet weather. The 3-inch size is a perfect universal fit and sits well on my boots without shifting.\nThe nylon straps are adjustable, comfortable, and easy to tighten. They stay put during riding sessions and don’t dig in or fray. Great spurs for both training and everyday riding."
      },
      {
        "variant": "",
        "date": "20251029",
        "rating": 5,
        "title": "Well made spurs",
        "content": "These are well made spurs. They feel solid with a simple knub. It was confusing as the packaging does make them look gold, but they are silver. They come with nylon straps, though typically I do prefer leather straps for longevity, but the nylon is still sturdy enough and usable. Great basic spurs."
      },
      {
        "variant": "",
        "date": "20251026",
        "rating": 5,
        "title": "Woman’s Silver spurs",
        "content": "These spurs are beautiful. Come with leathers to attach them. Fit as expected. I will say the packaging makes them appear gold and they are very much silver. I didn’t feel like docking an entire “star” because the product itself is completely as expected and durable/great quality. A little confusing for buyers but they are silver."
      },
      {
        "variant": "",
        "date": "20251025",
        "rating": 5,
        "title": "Great Spurs",
        "content": "These are great spurs.\nThey are well made of great materials.\n\nThese are recommended."
      }
    ],
    "bits": [
      {
        "variant": "",
        "date": "20251005",
        "rating": 5,
        "title": "This is the perfect bit for my mare!",
        "content": "I‘ve tried out a snaffle bits on my mare in the past and I’ve seen and feel a complete difference in how she responds to my commands. She’s so much more comfortable. Understandably, The type of bit that is selected for any horse depends on many factors factors and sometimes it takes a little time to get it right. But, I finally feel like I got it right with this one. Some experimenting was necessary to find the perfect fit and ensure comfort and effective communication and this finally feels like the right bit.\nShe’s 14 years old. She is broken but she’s light on the mouth. So the other bits that I’ve tried on her didn’t agree with her because she was so hard to control by reign. Me and my daughter were both about to give up but we didn’t. Now, she is perfect on the trails and we love it. Some particular qualities that I’d like to point out is that this ring snaffles are made from a good grade and high quality iron making it very durable and long lasting.\n\nOverall, It’s the perfect fit for my girl and it’s comfortable in her mouth and that’s all that I look for in a quality bit. I definitely recommend this to those horse riders that have not tried on yet."
      }
    ],
    "groomingTote": [
      {
        "variant": "Ancora red",
        "date": "20251020",
        "rating": 5,
        "title": "Really glad I ordered this!",
        "content": "Lotsa room and great pockets!"
      }
    ],
    "meshGrooming": [
      {
        "variant": "Sand",
        "date": "20251111",
        "rating": 5,
        "title": "true to size",
        "content": "10/10"
      }
    ],
    "hayBag": [],
    "dogCover": []
  }
};
